module.exports = __webpack_public_path__ + "static/media/RWBRedShirt.7b3451af.jpg";